import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

const instantSchema = z.iso.datetime({ offset: true })
const capturedEventSchema = z
  .object({
    eventId: entityIdSchema,
    capturedAt: instantSchema,
    effectiveAt: instantSchema,
  })
  .strict()
  .refine((value) => value.capturedAt >= value.effectiveAt, {
    path: ["capturedAt"],
    message: "Capture time cannot precede effective time.",
  })

export const visitTimeStateV1Schema = z.enum(["Running", "Paused", "Ended"])

export const visitTimeStartV1Schema = capturedEventSchema
  .extend({
    visitTimeId: entityIdSchema,
    visitId: entityIdSchema,
    workShiftId: entityIdSchema,
    workerId: entityIdSchema,
  })
  .strict()

export const visitTimePauseV1Schema = capturedEventSchema
  .extend({
    reason: z.string().trim().min(1).max(500),
  })
  .strict()

export const visitTimeEventV1Schema = capturedEventSchema

export const visitTimeCorrectionRequestV1Schema = z
  .object({
    correctionId: entityIdSchema,
    visitTimeId: entityIdSchema,
    targetEventId: entityIdSchema,
    proposedEffectiveAt: instantSchema,
    reason: z.string().trim().min(1).max(2_000),
  })
  .strict()

export const visitTimeResultV1Schema = z
  .object({
    entityType: z.enum(["visit_time", "visit_time_correction"]),
    entityId: entityIdSchema,
    state: z.string().min(1).max(80),
    version: z.number().int().nonnegative(),
    visitId: entityIdSchema,
    workShiftId: entityIdSchema,
    workerId: entityIdSchema,
    legalEntityId: entityIdSchema,
    branchId: entityIdSchema,
    eventId: entityIdSchema.nullable(),
    correctedEventId: entityIdSchema.nullable(),
  })
  .strict()

export type VisitTimeStateV1 = z.infer<typeof visitTimeStateV1Schema>
export type VisitTimeStartV1 = z.infer<typeof visitTimeStartV1Schema>
export type VisitTimePauseV1 = z.infer<typeof visitTimePauseV1Schema>
export type VisitTimeEventV1 = z.infer<typeof visitTimeEventV1Schema>
export type VisitTimeCorrectionRequestV1 = z.infer<
  typeof visitTimeCorrectionRequestV1Schema
>
export type VisitTimeResultV1 = z.infer<typeof visitTimeResultV1Schema>
